import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { FC } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { LoanFormType } from 'views/orders/loans/types';

import { AssumptionForm } from './components/assumption-form';
import { DemandFeatureForm } from './components/demand-feature-form';
import { EscrowAccountForm } from './components/escrow-account-form';
import { LiabilityForm } from './components/liability-form';
import { NegativeAmortizationForm } from './components/negative-amortization-form';
import { PartialPaymentsForm } from './components/partial-payments';

const useStyles = makeStyles((theme: any) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2.5),
  },
  pairRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(2.5),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
}));

type Props = {
  loanForm: UseFormReturn<LoanFormType, object>,
  isDataLoading: boolean,
  onSave: (e?: React.BaseSyntheticEvent<object, any, any> | undefined) => Promise<void>;
}

export const Disclosures: FC<Props> = ({
  loanForm,
  isDataLoading,
  onSave
}) => {
  const { control, setValue } = loanForm;
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Box className={classes.pairRow}>
        <LiabilityForm
          control={control}
          isDataLoading={isDataLoading}
          onSave={onSave}
        />

        <NegativeAmortizationForm
          control={control}
          isDataLoading={isDataLoading}
          onSave={onSave}
        />
      </Box>

      <Box className={classes.pairRow}>
        <AssumptionForm
          control={control}
          isDataLoading={isDataLoading}
          onSave={onSave}
        />

        <PartialPaymentsForm
          control={control}
          isDataLoading={isDataLoading}
          onSave={onSave}
        />
      </Box>

      <Box className={classes.pairRow}>
        <DemandFeatureForm
          control={control}
          isDataLoading={isDataLoading}
          onSave={onSave}
        />

        <EscrowAccountForm
          control={control}
          isDataLoading={isDataLoading}
          setValue={setValue}
          onSave={onSave}
        />
      </Box>
    </Box>
  );
};
